export default "__VITE_ASSET__DcpujQtb__"